import classNames from "classnames";
import cls from "./ProductCard.module.scss"

export const containerClasses = (layout?: string) => classNames(cls["product-card"],
    layout === "grid-sm" && cls["product-card--layout--grid product-card--size--sm"],
    layout === "grid-nl" && cls["product-card--layout--grid product-card--size--nl"],
    layout === "grid-lg" && cls["product-card--layout--grid product-card--size--lg"],
    layout === "list" && cls["product-card--layout--list"],
    layout === "horizontal" && cls["product-card--layout--horizontal"],
);